if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      this.updateHeight = () => document.documentElement.style.setProperty('--st-pdp-sticky-height', `${this.offsetHeight}px`);
      this.updateHeight();
      if ('ResizeObserver' in window) {
        this.heightObserver = new ResizeObserver(this.updateHeight);
        this.heightObserver.observe(this);
      }

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
      this.heightObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      window.removeEventListener('resize', this.syncVisibility);
    }

    bindEvents() {
      this.syncVisibility = () => {
        const desktop = window.matchMedia('(min-width: 769px)').matches;
        const target = desktop ? this.productInfo : this.productForm;
        if (!target) return;
        const rect = target.getBoundingClientRect();
        const hide = desktop ? rect.bottom > 0 && rect.top < window.innerHeight : rect.bottom > 0;
        this.classList.toggle('sticky-atc-panel--out', hide);
      };
      this.visibilityObserver = new IntersectionObserver(this.syncVisibility);
      if (this.productForm) this.visibilityObserver.observe(this.productForm);
      if (this.productInfo) this.visibilityObserver.observe(this.productInfo);
      window.addEventListener('resize', this.syncVisibility);
      this.syncVisibility();

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}

